// Jornada de primeiro acesso (/v1/onboarding/journey). Espelha a feature
// `onboarding-journey` do back, que devolve SÓ id e estado de cada passo —
// título, texto, rota e tour vivem no catálogo do front (src/journey-catalog.ts).
// A separação é de propósito: mudar a redação de um passo é deploy do front, e
// o back não precisa saber como o passo se chama.
//
// Um endpoint só, e nenhuma escrita: os passos fecham como CONSEQUÊNCIA do que
// se faz nas outras telas (convidar alguém, provisionar um ramal). Quem os
// fecha invalida a chave ["onboarding","journey"] — ver src/hooks/use-onboarding.ts
// e o invalidador de src/hooks/use-users.ts.
import { api, toApiError } from "./client.js";

export type JourneyKind = "setup" | "seller";
export type JourneyStepStatus = "done" | "todo" | "blocked";

export interface JourneyStepState {
  id: string;
  status: JourneyStepStatus;
}

export interface Journey {
  journey: JourneyKind;
  steps: JourneyStepState[];
  done: number;
  total: number;
}

export async function getJourney(): Promise<Journey> {
  const { data, error } = await api<Journey>("/v1/onboarding/journey");
  if (error) throw toApiError("GET /v1/onboarding/journey", error);
  return data;
}
